import React from 'react';
import { StarIcon } from 'lucide-react';
import { coaches } from '../data/coaches';
export function RatingProof() {
  return <div className="flex items-center gap-3" data-id="element-288" data-mp="36s94nzmmqsx0">
      <div className="flex -space-x-2" data-id="element-289" data-mp="3bqkfackr17ga">
        {coaches.map(coach => <img key={coach.name} src={coach.avatar} alt={`${coach.name}, ${coach.role}`} className="h-9 w-9 rounded-full object-cover ring-2 ring-white" loading="lazy" data-id="element-290" data-mp="3bohcst2etluo" />)}
      </div>
      <div className="text-[13px] leading-tight text-navy-soft" data-id="element-291" data-mp="3pgxloahzse3i">
        <div className="flex items-center gap-0.5" role="img" aria-label="Rated 4.9 out of 5" data-id="element-292" data-mp="3uhbisxi223mr">
          {Array.from({
          length: 5
        }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-peach text-peach" aria-hidden="true" data-id="element-293" data-mp="2030typ1gn9gz" data-mpi={i} />)}
          <span className="ml-1.5 font-semibold text-navy" data-id="element-294" data-mp="252nhbrb0663i">4.9/5</span>
        </div>
        <p className="mt-1" data-id="element-295" data-mp="1ed27ldbvqtr8">
          Loved by <span className="font-semibold text-navy" data-id="element-296" data-mp="1ee4xbhxguq5k">1,200+</span>{' '}
          therapists &amp; counselors
        </p>
      </div>
    </div>;
}